/**
 * TertiaryMenu
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';
import classNames from 'classnames';

function TertiaryMenu(props) {
	return (
		<div data-wrapper className={ styles.tertiaryMenu }>
			<div
				className={ classNames({
					[props.className]: props.className
				}) }
				{ ...props }
			/>
		</div>
	);
}

TertiaryMenu.displayName = 'TertiaryMenu';

TertiaryMenu.propTypes = {
	className: PropTypes.string
};

TertiaryMenu.defaultProps = {
	className: null
};

export default TertiaryMenu;
